import React from "react";

/**
 * Sort control (Figma "Arrow - both", 113:5071) — exact Figma glyph: two
 * rounded 7.2x4.8 triangles with a 2px gap, centered in a 16x24 slot.
 * `upClassName`/`downClassName` highlight one half for the active direction.
 */
export const SortArrowsIcon: React.FC<{
  className?: string;
  upClassName?: string;
  downClassName?: string;
}> = ({ className, upClassName, downClassName }) => (
  <svg
    className={className}
    viewBox="0 0 16 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g transform="translate(4.4 6.2)">
      <path
        className={upClassName}
        d="M0.547562 4.8H6.65244C7.13929 4.8 7.3831 4.11843 7.03885 3.71981L3.98641 0.185332C3.773 -0.0617775 3.427 -0.0617769 3.21359 0.185332L0.161151 3.71981C-0.183103 4.11843 0.060713 4.8 0.547562 4.8Z"
      />
      <path
        className={downClassName}
        d="M6.65244 6.80005H0.547561C0.0607123 6.80005 -0.183102 7.48162 0.161151 7.88024L3.21359 11.4147C3.427 11.6618 3.773 11.6618 3.98641 11.4147L7.03885 7.88024C7.3831 7.48162 7.13929 6.80005 6.65244 6.80005Z"
      />
    </g>
  </svg>
);

export const StarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M10 1.6 12.57 6.8l5.74.84-4.15 4.05.98 5.71L10 14.7l-5.14 2.7.98-5.71-4.15-4.05 5.74-.84L10 1.6Z" />
  </svg>
);

export const AppleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M14.09 10.63c-.02-1.55.7-2.72 2.15-3.58-.81-1.16-2.04-1.8-3.66-1.92-1.53-.12-3.2.9-3.82.9-.65 0-2.14-.86-3.31-.86C3.03 5.21 .47 7.1 .47 10.95c0 1.14.21 2.31.62 3.52.56 1.6 2.57 5.5 4.66 5.44 1.1-.03 1.87-.78 3.3-.78 1.38 0 2.1.78 3.31.78 2.12-.03 3.94-3.58 4.47-5.18-2.84-1.33-2.74-3.9-2.74-4.1ZM11.64 3.62c1.18-1.4 1.07-2.68 1.04-3.14-1.04.06-2.24.71-2.93 1.5-.75.85-1.19 1.9-1.1 3.08 1.13.09 2.16-.49 2.99-1.44Z" />
  </svg>
);

export const GooglePlayIcon: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M2.6 1.02 12.05 10.5 2.6 19.98A2.03 2.03 0 0 1 1.88 18.42V2.58c0-.63.28-1.19.72-1.56Zm10.05 10.19 2.1 2.11-9.32 5.4 7.22-7.51Zm2.66-3.43 2.62 1.52a1.36 1.36 0 0 1 0 2.36l-2.62 1.52-2.35-2.34 2.35-3.06ZM5.43 1.28l9.32 5.4-2.1 2.11-7.22-7.51Z" />
  </svg>
);

export const TrashIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M3.1 5.3h13.8" />
    <path d="M7.9 3h4.2" />
    <path d="M4.7 5.3l.75 11a1.7 1.7 0 0 0 1.7 1.6h5.7a1.7 1.7 0 0 0 1.7-1.6l.75-11" />
    <path d="M8.1 8.8v5.5" />
    <path d="M11.9 8.8v5.5" />
  </svg>
);

export const CheckIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M4.5 10.5 8.2 14 15.5 6.5" />
  </svg>
);

export const MinusIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M5 10h10" />
  </svg>
);
